/**
 * Toasts.jsx — Stacked, self-dismissing notifications.
 * Anchored bottom-left so it never collides with the (+) launcher / arrange
 * bar (bottom-right) or the tab toggle (top-left).
 */
import { For, Show } from 'solid-js';
import toast from '../lib/toastStore.js';
import { EMOJI } from '../lib/emoji.js';
import './Toasts.css';

const ICON = { success: EMOJI.ok, info: EMOJI.info, warn: EMOJI.warn, error: EMOJI.err };

export default function Toasts() {
  return (
    <div class="v2-toasts" role="status" aria-live="polite">
      <For each={toast.state.toasts}>{(t) => (
        <div class={`v2-toast v2-toast--${t.kind}`} onClick={() => toast.dismiss(t.id)}>
          <span class="v2-toast__icon">{ICON[t.kind] || '•'}</span>
          <div class="v2-toast__body">
            <div class="v2-toast__msg">{t.msg}</div>
            <Show when={t.detail}><div class="v2-toast__detail">{t.detail}</div></Show>
          </div>
          <button class="v2-toast__close" title="Dismiss"
            onClick={(e) => { e.stopPropagation(); toast.dismiss(t.id); }}>✖</button>
        </div>
      )}</For>
    </div>
  );
}
